import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "@/components/marketing/Nav";
import { Footer } from "@/components/marketing/Footer";
import { Home } from "./pages/Home";
import { Features } from "./pages/Features";
import { Pricing } from "./pages/Pricing";
import { HowItWorks } from "./pages/HowItWorks";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { RoleDetail } from "./pages/RoleDetail";
import { Register } from "./pages/Register";
import { RegisterCheckEmail } from "./pages/RegisterCheckEmail";
import { ComingSoon } from "./pages/ComingSoon";

// Marketing shell — virtualdesk.ai / www.virtualdesk.ai / localhost.
// Dark-mode default matches the VirtualDesk brand. Routes span the full marketing IA.
export function MarketingShell() {
  const loc = useLocation();

  // Ensure dark theme on marketing routes (explicitly remove the .light class the
  // legacy shell used to set).
  useEffect(() => {
    document.documentElement.classList.remove("light");
  }, []);

  // Scroll to top on every route change so users never land mid-page.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-brand-midnight text-brand-ink flex flex-col">
      <Nav />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/roles/:code" element={<RoleDetail />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/check-email" element={<RegisterCheckEmail />} />
          <Route
            path="/blog"
            element={
              <ComingSoon
                title="Blog launching soon"
                body="Long-form writing from the team lands here shortly. Until then, follow us on X for the play-by-play."
              />
            }
          />
          <Route
            path="/changelog"
            element={
              <ComingSoon
                title="Changelog launching soon"
                body="We'll post every product release here. In the meantime, Growth customers see changelogs in-app."
              />
            }
          />
          <Route
            path="/roadmap"
            element={
              <ComingSoon
                title="Roadmap launching soon"
                body="A public roadmap is on the way. Enterprise customers can request the private version from their CSM."
              />
            }
          />
          <Route
            path="/docs"
            element={
              <ComingSoon
                title="Docs launching soon"
                body="API and agent-configuration docs land with the public GA. Design partners: check your shared Notion."
              />
            }
          />
          <Route
            path="/careers"
            element={
              <ComingSoon
                title="Careers page coming soon"
                body="We're a small team hiring thoughtfully. Email hello@virtualdesk.ai with what you'd love to work on."
              />
            }
          />
          <Route
            path="/status"
            element={
              <ComingSoon
                title="Status page coming soon"
                body="Our status page will publish uptime, incidents, and maintenance windows. For now, incidents are emailed directly."
              />
            }
          />
          <Route
            path="/security"
            element={
              <ComingSoon
                title="Security page coming soon"
                body="SOC 2 Type II is in progress. Enterprise prospects can request our security questionnaire from sales@virtualdesk.ai."
              />
            }
          />
          <Route
            path="/privacy"
            element={<ComingSoon title="Privacy policy" body="Our full privacy policy is being finalized by counsel and lands before GA." />}
          />
          <Route
            path="/terms"
            element={<ComingSoon title="Terms of service" body="Our terms of service are being finalized by counsel and land before GA." />}
          />
          <Route
            path="/dpa"
            element={<ComingSoon title="Data processing agreement" body="Our DPA is available on request for Enterprise prospects — email sales@virtualdesk.ai." />}
          />
          <Route
            path="*"
            element={
              <ComingSoon
                title="Page not found"
                body="We couldn't find that page. Try the home page or the feature catalog."
              />
            }
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
